<template>
	<div class="poManage">
		<div class="poManageCon">
			<div class="head">
				<div class="left">
					<div class="label">
						<div v-for="(item,index) of statusList" :key='index' class="li"
							:class="{active:selectStatus==item.status}" @click="changeStatus(item.status)">
							{{item.name}}
						</div>
					</div>
				</div>
				<el-button type="primary" class="button" @click="editJob()"><span>+</span>发布职位</el-button>
			</div>
			<div v-loading="loading" class="content">
				<div class="nodata" v-if="list.length==0">
					<no-Data text="暂无职位信息"></no-Data>
				</div>
				<div v-for="(item,index) of list" :key="index" class="li">
					<div class="lis">
						<div class="left">
							<div class="name">
								{{item.position_name}}
							</div>
							<div class="info">
								{{item.address.split('-')[1]}} · {{item.tag_name_qualifications}}
								· {{item.tag_name_year}}
								·
								{{item.type!=2?`${parseFloat((item.salary_min/1000).toFixed(1))}-${parseFloat((item.salary_max/1000).toFixed(1))}k`:item.salary_part_time_job}}
								· {{item.type==0?'社招':item.type==1?'实习生招聘':'兼职招聘'}}
							</div>
						</div>
						<div class="right">
							<div class="status">
								<div class="dot"
									:style="{background:item.status=='1'||item.status=='3'?'#FF6666':item.status=='2'?'yellow':'#51A190'}">
								</div>
								<div>
									{{item.status=='0'?'开放中':item.status=='1'?'已关闭':item.status=='2'?'审核中':item.status=='3'?'审核失败':'草稿箱'}}
								</div>
							</div>
							<div class="controls">
								<div v-if="item.status=='0'" class="button" style="color: #51A190;" @click="pinned(item)">申请置顶</div>
								<div v-if="item.status=='0'" class="button" style="color: #51A190;" @click="refresh(item.id)">刷新职位</div>	
								<div v-if="item.status!='2'&&item.status!='1'" class="button" style="color: #9B6CFF;"
									@click="editJob(item.id)">编辑</div>
								<div v-if="item.status=='0'" class="button" style="color: #FF6666;"
									@click="stop(item.id,2)">停用</div>
								<div v-if="item.status=='1'" class="button" style="color: #51A190;"
									@click="stop(item.id,1)">启用</div>
							</div>
						</div>
					</div>
					<div v-if="item.status=='3'" class="red">
						拒绝理由：<span>{{item.remark}}</span>
					</div>
					<!-- <div v-if="item.status=='1'" class="masking"></div> -->
				</div>
			</div>


			<div v-if="total>limit" class="page">
				<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
					@current-change='changePage'>
				</el-pagination>
			</div>
			
		</div>
		
		<el-dialog
			title="置顶职位"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="600px">
			<div class="applybox" v-loading="applyLoading">
				<div class="positionName">申请职位： <span>{{position_name}}</span></div>
				<div class="tips">发起置顶申请后，平台工作人员会尽快与您取得联系，请保持当前账号电话号码畅通。</div>
				<div style="margin-bottom: 18px;">备注信息：</div>
				<el-input type="textarea" v-model="msg" style="width: 100%;" rows="5"></el-input>
				<div style="text-align: center;margin-top: 18px;">
				  <el-button @click="dialogVisible = false">取 消</el-button>
				  <el-button type="primary" @click="pinnedRequest()">申请置顶</el-button>
				</div>
			</div>
		  
		</el-dialog>


	</div>
</template>

<script>
	export default {
		name: 'poManage',
		data() {
			return {
				statusList: [{
						name: '开放中',
						status: 0
					},
					{
						name: '已关闭',
						status: 1
					},
					{
						name: '审核中',
						status: 2
					},
					{
						name: '审核失败',
						status: 3
					},
					{
						name: '草稿',
						status: 8
					},
				],
				selectStatus: 0,
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit: 15,
				dialogVisible:false,
				position_name:'',
				id:'',
				msg:'',
				applyLoading:false,
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList() {
				this.loading = true
				let data = {
					page:this.page,
					status: this.selectStatus
				}
				this.$axios.get('/api/client/ES/getPositionList', {
					params: data
				}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			editJob(id) {
				this.$router.push({
					name: 'postJob',
					query: {
						id: id
					}
				});
			},
			changeStatus(status) {
				this.selectStatus = status
				this.page = 1
				this.getList()
			},
			refresh(id) {
				this.$confirm('此操作将刷新本职位并消耗一次职位刷新次数，是否继续？', '刷新职位', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$axios.post('/api/client/ES/PositionRefreshs', { id: id }).then(res => {
						if (res.code == 200) {
							this.loading = false
							this.$eltips(res.msg, 'success')
						} else {
							this.loading = false
							this.$eltips(res.msg, 'error')
						}
					})
				}).catch(() => {});
			},
			remove(id) {
				this.$confirm('确认删除该职位?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$axios.post('/api/client/ES/deletePosition', {
						id: id
					}).then(res => {
						if (res.code == 200) {
							this.loading = false
							this.$eltips('删除成功')
						} else {
							this.loading = false
							this.$eltips(res.msg, 'error')
						}
					})
				}).catch(() => {});
			},
			//置顶
			pinned(item) {
				this.id=item.id
				this.position_name = item.position_name
				this.msg=''
				this.dialogVisible=true
			},
			pinnedRequest(){
				this.applyLoading = true
				this.$axios.post('/api/client/ES/positionTopApply', { id: this.id, msg:this.msg }).then(res => {
					this.applyLoading = false
					if (res.code == 200) {
						this.$eltips('申请成功')
						this.dialogVisible=false
						this.getList()
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			// 停用和启用
			stop(id,type){
				this.loading = true
				this.$axios.post('/api/client/ES/positionStartStop', {
					id: id,
					type:type
				}).then(res => {
					if (res.code == 200) {
						this.loading = false
						this.$eltips(type==1?'已启用':'已停用')
						this.getList()
					} else {
						this.loading = false
						this.$eltips(res.msg, 'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.poManage {
		position: relative;
		padding: 24px 0;
		display: flex;
		justify-content: center;
		.page {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 28px 0 0;
		}

		.poManageCon {
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;

			.head {
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				.left {
					flex: 1;
					display: flex;
					align-items: center;
					background-color: #FFF;
					padding: 20px 48px;
					border-radius: 16px;
					margin-right: 16px;

					.label {
						display: flex;
						align-items: center;

						.li {
							color: #151515;
							font-size: 18px;
							font-weight: bold;
							margin-right: 74px;
							cursor: pointer;
							line-height: 1;
							&:hover {
								color: #51A190;
							}
						}

						.active {
							color: #51A190;
							position: relative;

							&::after {
								content: '';
								display: block;
								width: 20px;
								height: 4px;
								background-color: #9B6CFF;
								border-radius: 16px;
								bottom: -12px;
								left: 50%;
								position: absolute;
								transform: translate(-50%, 0);
							}
						}
					}
				}

				.button {
					width: 170px;
					height: 56px;
					background-color: #51A190;
					border-radius: 16px;
					font-size: 18px;
					span {
						margin-right: 4px;
					}
				}
			}

			.content {
				min-height: 400px;
				border-radius: 16px;
				overflow: hidden;
				.nodata{
					min-height: 400px;
					border-radius: 16px;
					background: #FFF;
				}
				.li {
					background-color: #FFF;
					padding: 28px 38px;
					border-radius: 16px;
					margin-bottom: 24px;
					position: relative;

					.masking {
						position: absolute;
						width: 100%;
						height: 100%;
						background-color: rgba(255, 255, 255, 0.8);
						border-radius: 16px;
						left: 0;
						top: 0;
						z-index: 2;
					}

					.lis {
						display: flex;
						align-items: center;
						justify-content: space-between;

					}

					.red {
						font-size: 14px;
						margin-top: 20px;
						// color: red;
						span{
							color: #F44;
						}
					}

					&:last-child {
						margin-bottom: 0;
					}

					.left {
						color: #151515;
						flex: 5;

						.name {
							font-size: 20px;
							margin-bottom: 10px;
						}

						.info {
							font-size: 14px;
						}
					}

					.right {
						flex: 4;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.status {
							display: flex;
							align-items: center;
							font-size: 16px;

							.dot {
								width: 12px;
								height: 12px;
								border-radius: 50%;
								background-color: #51A190;
								margin-right: 6px;
							}

							color: #151515;
						}

						.controls {
							display: flex;
							align-items: center;

							.button {
								margin-right: 38px;
								font-size: 16px;
								cursor: pointer;

								&:last-child {
									margin-right: 0;
								}
							}
						}
					}
				}
			}
		}
	}

	.applybox{
		.positionName{
			font-size: 15px;
			margin-bottom: 18px;
			span{
				color: #51A190;
			}
		}
		.tips{
			margin-bottom: 28px;
		}
	}
</style>
